<template>
  <div class="collection-container">
    <el-card class="collection-card">
      <div class="collection-wrapper">
        <div class="collection-cover">
          <CachedImage
            :src="collection.cover_url"
            :fallback-src="placeholderImage"
            :alt="collection.title"
            image-class="cover-image"
            fit="cover"
            width="250px"
            height="354px"
            lazy
            image-style="box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1); border-radius: 8px;"
          />
        </div>

        <div class="collection-content">
          <div class="collection-header">
            <el-avatar 
              :size="40" 
              :src="collection.user_avatar_address_small"
              :style="{
                border: getBorderStyleByUserType(collection.user_type),
                backgroundColor: collection.user_avatar_address_small && collection.user_avatar_address_small !== '' && collection.user_avatar_address_small !== 'undefined' ? 'white' : '#e0e0e0',
                fontSize: '20px',
                color: '#409EFF'
              }"
            >
              {{ collection.user_avatar_address_small && collection.user_avatar_address_small !== '' && collection.user_avatar_address_small !== 'undefined' ? '' : userInitial }}
            </el-avatar>
            <div class="collection-info">
              <h3>
                <router-link 
                 
                  :to="{ path: '/profile', query: { id: collection.user_id }}"
                  style="color: inherit; text-decoration: none;"
                >
                  {{ collection.user_name }}
                </router-link>
                <template v-if="collection.user_id === $store.state.user_id" >
                  (You)
                </template>
              </h3>
              <div class="collection-meta">
                <span>Latest update on: {{ formatDate((collection.update_time || collection.create_time) * 1000) }}</span>
                <span v-if="collection.version_identifier && collection.version_identifier !== ''" style="margin-left: 0px">| Version: {{ collection.version_identifier }}</span>
              </div>
            </div>
            <div class="collection-status" v-if="collection.user_id === $store.state.user_id">
              <el-tag
                :type="statusTagType"
                size="small"
                :class="statusClass"
              >
                {{ statusLabel }}
              </el-tag>
            </div>
          </div>

          <div class="collection-title">
            <p>{{ collection.title }}</p>
            <div class="price-tag">
              <span>{{ collectionPriceLabel }}</span>
            </div>
          </div>

          <CollectionSpecialLabels :labels="collection.special_labels" />
          <div class="collection-id-row" v-if="collectionIdStr && collection.user_id === $store.state.user_id">
            <span class="collection-id-label">ID:</span>
            <code class="collection-id-value">{{ collectionIdStr }}</code>
            <el-button
              type="text"
              size="mini"
              icon="el-icon-document-copy"
              class="collection-id-copy"
              @click.stop="copyCollectionId"
              title="Copy collection ID"
            ></el-button>
            <el-button
              type="text"
              size="mini"
              icon="el-icon-link"
              class="collection-id-copy"
              @click.stop="copyCollectionLink"
              title="Copy course link"
            ></el-button>
          </div>

          <div class="collection-description">
            <p>{{ collection.description }}</p>
          </div>

          <div class="collection-counts">
            <div class="count-items-left">
              <div class="count-item">
                <i class="el-icon-folder"></i>
                <span>{{ collection.group_count || 0 }} {{ (collection.group_count || 0) > 1 ? 'Groups' : 'Group' }}</span>
              </div>
              <div class="count-item">
                <i class="el-icon-document"></i>
                <span>{{ collection.knowit_count || collection.planned_knowit_count || 0 }} {{ (collection.knowit_count || collection.planned_knowit_count || 0) > 1 ? 'Stacks' : 'Stack' }}</span>
              </div>
              <div class="count-item" v-if="collection.content_count && collection.content_count > 0">
                <i class="el-icon-document-copy"></i>
                <span>{{ collection.content_count }} {{ collection.content_count > 1 ? 'Cards' : 'Card' }}</span>
              </div>
              <div class="count-item" v-if="collection.quiz_count && collection.quiz_count > 0">
                <i class="el-icon-question"></i>
                <span>{{ collection.quiz_count }} {{ collection.quiz_count > 1 ? 'Quizzes' : 'Quiz' }}</span>
              </div>
            </div>
            <div class="count-items-right">
              <div class="stats-display" v-if="!hideStats">
                <span style=""><i class="el-icon-view"></i> {{ collection.view_count || 0 }} Views</span>
                <span><i class="el-icon-star-off"></i> {{ collection.star_count || 0 }} Stars</span>
                <!-- && collection.order_complete_count && collection.order_complete_count > 0 -->
                <span v-if="collection.user_id === $store.state.user_id "

                      @click="viewCollectionOrders((collection._id.$oid || collection._id.$id))"
                      style="cursor: pointer; color: #409EFF; ">
                  <i class="el-icon-box"></i> {{ collection.order_complete_count || 0 }} Acquired
                </span>
              </div>

              </div>
          </div>

          <!-- Quiz Progress Section -->
          <div v-if="collection.quiz_count && collection.quiz_count > 0 && quizAnswerCount !== null" class="quiz-progress-section">
            <i class="el-icon-question"></i>
            <span class="quiz-progress-label">Quiz Progress:</span>
            <span class="quiz-progress-stats">{{ Math.min(quizAnswerCount, collection.quiz_count) }} / {{ collection.quiz_count }}</span>
            <el-progress
              :percentage="Math.min(100, Math.round((quizAnswerCount / collection.quiz_count) * 100 * 10) / 10)"
              :stroke-width="6"
              :show-text="true"
              :color="getProgressColor(Math.min(quizAnswerCount, collection.quiz_count), collection.quiz_count)"
              class="quiz-progress-bar"
            ></el-progress>
          </div>


          <!-- <div class="collection-preview"> -->
            <!-- <div class="preview-text" v-if="collection.view_status === 'NO' && collection.user_id !== $store.state.user_id">
              <i class="el-icon-lock"></i>
              <span>{{ collection.knowit_count || 0 }} Knowits in this collection</span>
            </div> -->
            <!-- <div class="knowits-preview" v-else>
              <div class="knowits-scroll">
                <el-card 
                  v-for="(knowit, index) in collection.groups?.[0]?.knowits?.slice(0, 3)" 
                  :key="index"
                  class="knowit-preview-card"
                  shadow="hover"
                >
                  <p class="knowit-title">{{ knowit.post_info?.title }}</p>
                </el-card>
                <div v-if="collection.knowit_count > 3" class="more-knowits">
                  +{{ collection.knowit_count - 3 }} more
                </div>
              </div>
            </div> -->
            <!-- <div v-if="!collection.groups?.[0]?.knowits?.length" class="preview-text">
              <i class="el-icon-document"></i>
              <span>No Knowits in this collection yet</span>
            </div> -->
          <!-- </div> -->
          <div class="collection-actions">
            <div class="action-buttons">
              <!-- If creator, show creator controls -->
              <div v-if="collection.user_id === $store.state.user_id">
                <el-button
                  plain
                  type="primary"
                  icon="el-icon-setting"
                  @click="openPublicityDialog"
                >
                  Manage Publicity
                </el-button>
                <el-button type="primary" icon="el-icon-edit" @click="editCollection">Edit</el-button>
                <el-button type="primary" @click="viewDetail">Overview</el-button>
                <el-button @click="previewRead" style="border-color: #409eff; color: #409eff;">View Content</el-button>
              </div>
              <!-- Not creator, show overview -->
              <div v-else>
                <el-button v-if="hasCollectionAccess" type="primary" @click="readCollection">Overview</el-button>
                <template v-else>
                  <el-button type="primary" @click="handlePurchase">{{ purchaseButtonLabel }}</el-button>
                  <el-button @click="$router.push('/platform-subscription')">Subscribe</el-button>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <el-dialog
      title="Manage Publicity"
      :visible.sync="publicityDialogVisible"
      width="620px"
      custom-class="publicity-dialog"
      :close-on-click-modal="!publicitySaving"
      :close-on-press-escape="!publicitySaving"
      :show-close="!publicitySaving"
      append-to-body
    >
      <div v-loading="publicityLoading" class="publicity-settings">
        <p class="publicity-intro">
          Control who can access this course and where it can be discovered.
        </p>

        <div class="publicity-setting-row">
          <div class="publicity-setting-copy">
            <div class="publicity-setting-title">
              Entire Course Behind Paywall
              <el-tooltip
                effect="dark"
                content="When enabled, non-subscribers cannot view any content in this course. They will be prompted to subscribe before entering."
                placement="top"
              >
                <i class="el-icon-info publicity-info-icon"></i>
              </el-tooltip>
            </div>
            <div class="publicity-setting-description">
              Require an active platform subscription to view any course content.
            </div>
          </div>
          <el-switch
            v-model="publicityForm.subscribers_only"
            :disabled="publicityLoading || publicitySaving"
            active-color="#e6a23c"
            inactive-color="#dcdfe6"
          ></el-switch>
        </div>

        <el-alert
          v-if="publicityForm.subscribers_only"
          title="Non-subscribers will be unable to view any content in this course."
          type="warning"
          :closable="false"
          show-icon
          class="publicity-paywall-alert"
        ></el-alert>

        <div class="publicity-setting-row">
          <div class="publicity-setting-copy">
            <div class="publicity-setting-title">
              Publicity Status
              <el-tooltip
                effect="dark"
                content="When made private, this course is hidden from the market. Users who already acquired it will retain access."
                placement="top"
              >
                <i class="el-icon-info publicity-info-icon"></i>
              </el-tooltip>
            </div>
            <div class="publicity-setting-description">
              Choose whether this course is hidden, available for pre-order, or published.
            </div>
          </div>
          <div class="publicity-status-control publicity-status-select-wrap">
            <el-select
              v-model="publicityForm.status"
              :disabled="publicityLoading || publicitySaving"
              size="small"
            >
              <el-option label="Private" value="PRIVATE"></el-option>
              <el-option label="Pre-order" value="PREORDER"></el-option>
              <el-option label="Published" value="PUBLISHED"></el-option>
            </el-select>
          </div>
        </div>

        <el-alert
          v-if="isPreorderStatus(publicityForm.status)"
          :title="'Pre-order keeps the course page visible while content stays locked. Buyers reserve at 50% off (' + formatMoney(getPreorderCollectionPrice()) + '), and subscribers can reserve with their plan.'"
          type="info"
          :closable="false"
          show-icon
          class="publicity-paywall-alert"
        ></el-alert>

        <div class="publicity-setting-row">
          <div class="publicity-setting-copy">
            <div class="publicity-setting-title">
              Show in public search?
              <el-tooltip
                effect="dark"
                content="If turned on, your collection can appear in users' public search results."
                placement="top"
              >
                <i class="el-icon-info publicity-info-icon"></i>
              </el-tooltip>
            </div>
            <div class="publicity-setting-description">
              Allow users to find this course through public search.
            </div>
          </div>
          <el-switch
            v-model="publicityForm.shown_in_public_search"
            :disabled="publicityLoading || publicitySaving"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
        </div>

        <div class="publicity-setting-row">
          <div class="publicity-setting-copy">
            <div class="publicity-setting-title">
              Visible in recommendation?
              <el-tooltip
                effect="dark"
                content="If turned off, this collection will not appear proactively in the Plaza, but it can still be found through public search when public search is enabled."
                placement="top"
              >
                <i class="el-icon-info publicity-info-icon"></i>
              </el-tooltip>
            </div>
            <div class="publicity-setting-description">
              Allow this course to appear in proactive recommendations.
            </div>
          </div>
          <el-switch
            v-model="publicityForm.visible_in_recommendation"
            :disabled="publicityLoading || publicitySaving"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
        </div>

        <div class="publicity-setting-row">
          <div class="publicity-setting-copy">
            <div class="publicity-setting-title">
              Learner Level
              <el-tooltip
                effect="dark"
                content="Who this course is designed for. Recommendations use it to match courses with learners."
                placement="top"
              >
                <i class="el-icon-info publicity-info-icon"></i>
              </el-tooltip>
            </div>
            <div class="publicity-setting-description">
              Pick the school stages this course targets; leave empty to target everyone.
            </div>
          </div>
          <el-select
            v-model="publicityForm.target_audience_stages"
            multiple
            :disabled="publicityLoading || publicitySaving"
            size="small"
            placeholder="All levels"
            class="publicity-stage-select"
          >
            <el-option label="Primary" value="primary"></el-option>
            <el-option label="Secondary" value="secondary"></el-option>
            <el-option label="Collegiate" value="collegiate"></el-option>
            <el-option label="Professional" value="professional"></el-option>
          </el-select>
        </div>

        <div class="publicity-setting-row">
          <div class="publicity-setting-copy">
            <div class="publicity-setting-title">
              Disable Single Purchase
              <el-tooltip
                effect="dark"
                content="When enabled, learners cannot buy this course on its own; it can only be accessed through a bundle."
                placement="top"
              >
                <i class="el-icon-info publicity-info-icon"></i>
              </el-tooltip>
            </div>
            <div class="publicity-setting-description">
              Turn on to stop individual purchases of this course.
            </div>
          </div>
          <el-switch
            v-model="publicityDisableSinglePurchase"
            :disabled="publicityLoading || publicitySaving"
            active-color="#e6a23c"
            inactive-color="#dcdfe6"
          ></el-switch>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button :disabled="publicitySaving" @click="publicityDialogVisible = false">
          Cancel
        </el-button>
        <el-button
          type="primary"
          :loading="publicitySaving"
          :disabled="publicityLoading"
          @click="savePublicity"
        >
          Save Changes
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { showCollectionLaunchNotification } from '@/utils/collectionLaunchNotification'
import CollectionSpecialLabels from "@/components/CollectionSpecialLabels.vue";
import { postRequest } from '@/apis/front'
import CachedImage from '@/components/CachedImage.vue'
import placeholderImageAsset from '@/assets/Card Collection Cover Placeholder.jpeg'

export default {
  name: 'Collection',
  components: {
    CollectionSpecialLabels,
    CachedImage
  },
  props: {
    collection: {
      type: Object,
      required: true
    },
    hideStats: {
      type: Boolean,
      default: false
    }
  },
  emits: ['like', 'showOrderSettings', 'publicity-updated'],
  computed: {
    userInitial() {
      return (this.collection.user_name || '').charAt(0);
    },
    quizAnswerCount() {
      const orderInfo = this.collection.order_info || {};
      return orderInfo.quiz_answer_count === undefined ? null : Number(orderInfo.quiz_answer_count || 0);
    },
    collectionIdStr() {
      const id = this.collection && this.collection._id;
      if (!id) return '';
      if (typeof id === 'string') return id;
      return id.$oid || id.$id || '';
    },
    publicityDisableSinglePurchase: {
      get() { return !this.publicityForm.single_purchase_enabled; },
      set(value) { this.publicityForm.single_purchase_enabled = !value; }
    },
    displayStatus() {
      return this.normalizePublicityStatus(this.savedPublicityStatus || this.collection.status);
    },
    effectiveCollectionPrice() {
      return this.getEffectiveCollectionPrice(this.collection);
    },
    preorderCollectionPrice() {
      return this.getPreorderCollectionPrice(this.collection);
    },
    isPreorderMode() {
      return this.isPreorderStatus(this.displayStatus);
    },
    collectionPriceLabel() {
      return this.formatMoney(this.effectiveCollectionPrice);
    },
    purchaseButtonLabel() {
      if (this.isPreorderMode) {
        if (this.hasPlatformSubscription) return 'Pre-order with Plan';
        return this.preorderCollectionPrice > 0
          ? `Pre-order · ${this.formatMoney(this.preorderCollectionPrice)}`
          : 'Pre-order';
      }
      return this.effectiveCollectionPrice > 0 ? `Buy · ${this.collectionPriceLabel}` : 'Claim Free';
    },
    statusLabel() {
      if (this.displayStatus === 'PUBLISHED') return 'PUBLISHED';
      if (this.isPreorderMode) return 'PRE-ORDER';
      if (this.displayStatus === 'DRAFT') return 'PRIVATE';
      return this.displayStatus || 'PROBLEM';
    },
    statusTagType() {
      if (this.displayStatus === 'PUBLISHED') return 'success';
      if (this.isPreorderMode) return 'warning';
      return 'info';
    },
    hasPlatformSubscription() {
      return Boolean(this.$store.state.platformSubscription && this.$store.state.platformSubscription.active);
    },
    hasPurchasedCollection() {
      const purchaseInfo = this.collection.purchase_info || {};
      const orderInfo = this.collection.order_info || {};
      return Boolean(
        purchaseInfo.owned ||
        orderInfo.type === 'SINGLE_PURCHASE' ||
        orderInfo.type === 'BUNDLE_PURCHASE' ||
        orderInfo.status === 'COMPLETE'
      );
    },
    hasCollectionAccess() {
      if (this.collection.user_id === this.$store.state.user_id) return true;
      if (this.isPreorderMode) return false;
      if (!this.collection.subscribers_only) return true;
      return this.hasPlatformSubscription || this.hasPurchasedCollection;
    },
    statusClass() {
      if (this.displayStatus === 'PUBLISHED') return 'status-published';
      if (this.isPreorderMode) return 'status-preorder';
      return 'status-private';
    }
  },
  data() {
    return {
      placeholderImage: placeholderImageAsset,
      publicityDialogVisible: false,
      publicityLoading: false,
      publicitySaving: false,
      publicitySettings: {},
      publicityUsdPrice: 0,
      publicityHasCustomPrice: false,
      publicityBaseCredits: 0,
      savedPublicityStatus: '',
      publicityForm: {
        subscribers_only: false,
        status: 'PRIVATE',
        shown_in_public_search: true,
        visible_in_recommendation: true,
        target_audience_stages: [],
        single_purchase_enabled: false
      }
    }
  },
  mounted() {
    console.log('[Collection.vue] Component mounted')
    console.log('[Collection.vue] Collection prop:', this.collection)
    console.log('[Collection.vue] Has order_info:', !!this.collection.order_info)
  },
  methods: {
    initializePublicityForm(collectionData) {
      const data = collectionData || {};
      const settings = data.settings || {};
      if (data.status) {
        this.savedPublicityStatus = this.normalizePublicityStatus(data.status);
      }
      this.publicitySettings = { ...settings };
      this.publicityUsdPrice = Number(data.usd_price || 0);
      this.publicityHasCustomPrice = data.has_custom_price === true;
      this.publicityBaseCredits = Number(data.base_credits || 0);
      this.publicityForm = {
        subscribers_only: Boolean(data.subscribers_only),
        status: this.normalizePublicityStatus(data.status || 'PRIVATE'),
        shown_in_public_search: settings.shown_in_public_search !== false,
        visible_in_recommendation: settings.visible_in_recommendation !== false,
        target_audience_stages: Array.isArray(data.target_audience_stages) ? data.target_audience_stages : [],
        single_purchase_enabled: data.single_purchase_enabled === true
      };
    },
    async openPublicityDialog() {
      this.publicityDialogVisible = true;
      this.publicityLoading = true;
      this.initializePublicityForm(this.collection);

      try {
        const response = await postRequest('getPostCollectionPublicitySettings', {
          collection_id: this.collectionIdStr,
          user_id: this.$store.state.user_id
        });

        if (response.data.code !== 0) {
          throw new Error(response.data.msg || 'Failed to load publicity settings');
        }

        const collectionData = response.data.data || {};
        this.initializePublicityForm(collectionData);
      } catch (error) {
        this.$message.error(error.message || 'Failed to load publicity settings');
        this.publicityDialogVisible = false;
      } finally {
        this.publicityLoading = false;
      }
    },
    async confirmFreePublicationIfNeeded() {
      const wasPublished = this.normalizePublicityStatus(this.savedPublicityStatus || this.collection.status) === 'PUBLISHED';
      const purchasePrice = this.getEffectiveCollectionPrice({
        has_custom_price: this.publicityHasCustomPrice,
        usd_price: this.publicityUsdPrice,
        base_credits: this.publicityBaseCredits
      });
      if (wasPublished || this.publicityForm.status !== 'PUBLISHED' || purchasePrice > 0) {
        return true;
      }

      try {
        await this.$confirm(
          'You are about to publish this course for free. Are you sure you want to make it publicly available without charging?',
          'Confirm Free Publication',
          {
            confirmButtonText: 'Yes, Publish for Free',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }
        );
        return true;
      } catch (error) {
        return false;
      }
    },
    async savePublicity() {
      if (!(await this.confirmFreePublicationIfNeeded())) return;

      this.publicitySaving = true;
      const status = this.normalizePublicityStatus(this.publicityForm.status || 'PRIVATE');
      const settings = {
        ...this.publicitySettings,
        shown_in_public_search: this.publicityForm.shown_in_public_search,
        visible_in_recommendation: this.publicityForm.visible_in_recommendation
      };

      try {
        const response = await postRequest('updatePostCollectionPublicitySettings', {
          collection_id: this.collectionIdStr,
          user_id: this.$store.state.user_id,
          subscribers_only: this.publicityForm.subscribers_only,
          status,
          shown_in_public_search: this.publicityForm.shown_in_public_search,
          visible_in_recommendation: this.publicityForm.visible_in_recommendation,
          target_audience_stages: this.publicityForm.target_audience_stages,
          single_purchase_enabled: this.publicityForm.single_purchase_enabled
        });

        if (response.data.code !== 0) {
          throw new Error(response.data.msg || 'Failed to update publicity settings');
        }

        this.savedPublicityStatus = status;
        this.publicitySettings = settings;
        this.$emit('publicity-updated', {
          collection_id: this.collectionIdStr,
          subscribers_only: this.publicityForm.subscribers_only,
          status,
          settings
        });
        this.publicityDialogVisible = false;
        this.$message.success('Publicity settings updated');
        showCollectionLaunchNotification(this.$message, response.data.launch_notification);
      } catch (error) {
        this.$message.error(error.message || 'Failed to update publicity settings');
      } finally {
        this.publicitySaving = false;
      }
    },
    copyCollectionId() {
      const id = this.collectionIdStr;
      if (!id) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(id).then(() => {
          this.$message.success('Collection ID copied');
        }).catch(() => {
          this.$message.error('Failed to copy');
        });
      } else {
        const ta = document.createElement('textarea');
        ta.value = id;
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); this.$message.success('Collection ID copied'); }
        catch (e) { this.$message.error('Failed to copy'); }
        document.body.removeChild(ta);
      }
    },
    copyCollectionLink() {
      const id = this.collectionIdStr;
      if (!id) return;
      const url = `https://learningfirst.io/collection/${id}`;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(() => {
          this.$message.success('Course link copied');
        }).catch(() => {
          this.$message.error('Failed to copy');
        });
      } else {
        const ta = document.createElement('textarea');
        ta.value = url;
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); this.$message.success('Course link copied'); }
        catch (e) { this.$message.error('Failed to copy'); }
        document.body.removeChild(ta);
      }
    },
    handleOrderSettingsClick() {
      console.log('[Collection.vue] Order & Settings button clicked')
      console.log('[Collection.vue] Collection object:', this.collection)
      console.log('[Collection.vue] Order info:', this.collection.order_info)
      this.$emit('showOrderSettings')
      console.log('[Collection.vue] Event emitted: showOrderSettings')
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString()
    },
    getEffectiveCollectionPrice(collection) {
      if (!collection) return 0
      const rawPrice = collection.has_custom_price === true
        ? collection.usd_price
        : collection.base_credits
      const price = Number(rawPrice)
      return Number.isFinite(price) && price > 0 ? Math.round(price * 100) / 100 : 0
    },
    getPreorderCollectionPrice(collection = this.collection) {
      if (!collection) return 0
      const backendPrice = Number(collection.preorder_price)
      if (Number.isFinite(backendPrice) && backendPrice > 0) {
        return Math.round(backendPrice * 100) / 100
      }
      const price = this.getEffectiveCollectionPrice(collection)
      return price > 0 ? Math.round(price * 50) / 100 : 0
    },
    isPreorderStatus(status) {
      return ['PREORDER', 'TEASER', 'REQUEST'].includes(status)
    },
    normalizePublicityStatus(status) {
      return this.isPreorderStatus(status) ? 'PREORDER' : (status || 'PRIVATE')
    },
    formatMoney(value) {
      const amount = Number(value)
      return amount > 0 ? `$${amount.toFixed(2)}` : 'FREE'
    },
    handleLike() {
      this.$emit('like', (this.collection._id.$oid || this.collection._id.$id))
    },
    viewDetail() {
      const id = this.collection._id.$oid || this.collection._id.$id
      this.$store.dispatch('setTempCollectionId', id)
      this.$router.push({ path: '/deck', query: { id } })
    },
    editCollection() {
      this.$store.dispatch('setTempCollectionId', (this.collection._id.$oid || this.collection._id.$id))
      this.$router.push('/edit-deck')
    },
    async handlePurchase() {
      if (!this.$store.state.user_id) {
        this.$router.push('/login')
        return
      }
      const id = this.collection._id.$oid || this.collection._id.$id
      this.$store.dispatch('setTempCollectionId', id)
      this.$router.push({ path: '/collection-order', query: { collection_id: id } })
    },
    readCollection() {
      this.$store.dispatch('setTempCollectionId', (this.collection._id.$oid || this.collection._id.$id))
      this.$router.push('/read-collection')
    },
    previewRead() {
      this.$store.dispatch('setTempCollectionId', (this.collection._id.$oid || this.collection._id.$id))
      this.$router.push({
        path: '/read-collection',
        query: { collection_id: (this.collection._id.$oid || this.collection._id.$id) }
      })
    },
    getBorderStyleByUserType(userType) {
      // Default to Individual if not set
      const type = userType || 'individual';
      
      switch(type) {
        case 'individual':
          return '1px solid #1890ff'; // Theme blue border
        case 'institution':
          return '1px solid #67C23A'; // Green border for institutions
        case 'agent':
          return '1px solid #E6A23C'; // Orange border for agents
        default:
          return '1px solid #e0e0e0'; // Default gray border
      }
    },
    viewCollectionOrders(collectionId) {
      this.$router.push({
        path: '/collection-orders',
        query: { collection_id: collectionId }
      })
    },
    getProgressColor(answered, total) {
      const percentage = (answered / total) * 100
      if (percentage === 100) return '#67C23A' // Green for complete
      if (percentage >= 50) return '#409EFF' // Blue for good progress
      if (percentage >= 25) return '#E6A23C' // Orange for some progress
      return '#F56C6C' // Red for low progress
    }
  }
}
</script>

<style scoped>
.stats-display {
  color: #909399;
  font-size: 14px;
  display: flex;
  gap: 15px;
}
.stats-display span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.stats-display i {
  margin-right: 2px;
}
.collection-container {
  margin-right: 5px;
}

.collection-card {
  width: 100%;
  margin: 20px 0;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.collection-wrapper {
  display: flex;
  gap: 20px;
}

.collection-cover {
  flex: 0 0 106px;
  height: 100%;
}

.cover-image {
  width: 250px;
  height: 354px;
  object-fit: cover;
  border-radius: 8px;
  min-height: 354px;
}

.collection-content {
  flex: 1;
}

.collection-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  position: relative;
}

.collection-info {
  margin-left: 15px;
}

.collection-info h3 {
  margin: 0;
  font-size: 18px;
}

.collection-meta {
  font-size: 14px;
  color: #8c8c8c;
}

.collection-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.collection-title p {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: #303133;
  flex: 1;
}

.collection-id-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  font-size: 12px;
  color: #909399;
}
.collection-id-label {
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-size: 11px;
}
.collection-id-value {
  font-family: 'SF Mono', Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  background: #f5f7fa;
  padding: 2px 8px;
  border-radius: 4px;
  color: #606266;
  user-select: all;
}
.collection-id-copy {
  padding: 2px !important;
  color: #909399 !important;
}
.collection-id-copy:hover {
  color: #409EFF !important;
}

.price-tag {
  background: #409EFF;
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-weight: 600;
  font-size: 16px;
}

.collection-description p {
  font-size: 14px;
  color: #606266;
  margin-bottom: 15px;
}

.knowits-scroll {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding: 10px 0;
}

.knowit-preview-card {
  min-width: 200px;
  max-width: 200px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.knowit-title {
  text-align: center;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.more-knowits {
  min-width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  border-radius: 4px;
  color: #909399;
}

.collection-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 15px;
  padding-top: 15px;
}

.action-buttons {
  text-align: right;
  display: flex;
  justify-content: flex-end;
}

.action-buttons > div {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
}

.action-buttons > div .el-button + .el-button {
  margin-left: 0;
}

.publicity-settings {
  min-height: 280px;
}

.publicity-intro {
  color: #606266;
  margin: -4px 0 8px;
}

.publicity-setting-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 18px 0;
  border-bottom: 1px solid #ebeef5;
}

.publicity-setting-row:last-child {
  border-bottom: 0;
}

.publicity-stage-select {
  width: 200px;
}
.publicity-setting-copy {
  flex: 1;
  min-width: 0;
}

.publicity-setting-title {
  color: #303133;
  font-size: 15px;
  font-weight: 600;
}

.publicity-setting-description {
  color: #909399;
  font-size: 13px;
  line-height: 1.45;
  margin-top: 4px;
}

.publicity-info-icon {
  color: #909399;
  cursor: help;
  margin-left: 4px;
}

.publicity-paywall-alert {
  margin: 0 0 2px;
}

.publicity-status-control {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 9px;
}

.publicity-status-select-wrap {
  width: 210px;
}

.publicity-status-select-wrap .el-select {
  width: 100%;
}

.publicity-status-control span {
  color: #c0c4cc;
  font-size: 13px;
  font-weight: 600;
}

.publicity-status-control span.active {
  color: #303133;
}

.button-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  
}

.note-text {
  font-size: 12px;
  color: #909399;
  
}

.preview-text {
  text-align: center;
  color: #909399;
  padding: 20px;
  background: #f5f7fa;
  border-radius: 4px;
}

.collection-counts {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 15px;
}

.count-items-left {
  display: flex;
  gap: 20px;
}

.count-items-right {
  margin-left: auto;
}

.quiz-progress-section {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
  margin-bottom: 12px;
  padding: 10px 12px;
  background: #f9fafb;
  border-radius: 6px;
  border: 1px solid #e8ecf0;
  font-size: 13px;
  color: #606266;
}

.quiz-progress-section i {
  font-size: 14px;
  color: #909399;
  flex-shrink: 0;
}

.quiz-progress-label {
  font-weight: 500;
  flex-shrink: 0;
}

.quiz-progress-stats {
  color: #606266;
  font-weight: 600;
  flex-shrink: 0;
}

.quiz-progress-bar {
  flex: 1;
  min-width: 150px;
}

.count-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #606266;
  font-size: 14px;
}

.count-item i {
  color: #409EFF;
  font-size: 16px;
}

.collection-status {
  position: absolute;
  right: 0;
  top: 0;
}

.collection-status .status-published {
  background-color: #67C23A !important;
  border-color: #67C23A !important;
  color: white !important;
  font-weight: 600 !important;
}

.collection-status .status-private {
  background-color: #E6A23C !important;
  border-color: #E6A23C !important;
  color: white !important;
  font-weight: 600 !important;
}

.collection-status .status-preorder {
  background-color: #409EFF !important;
  border-color: #409EFF !important;
  color: white !important;
  font-weight: 600 !important;
}

.collection-meta span {
  margin-right: 8px;
}

.cover-placeholder {
  width: 250px;
  height: 354px;
  background-color: #f5f7fa;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
}

.cover-placeholder i {
  font-size: 48px;
  margin-bottom: 12px;
}

.cover-placeholder span {
  font-size: 14px;
}

.image-placeholder {
  width: 250px;
  height: 354px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-placeholder i {
  font-size: 48px;
  color: #c0c4cc;
}

.image-placeholder .placeholder-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

</style>

<style>
.publicity-dialog {
  width: calc(100% - 32px) !important;
  max-width: 620px;
}
</style>
